import React from 'react';
import classNames from 'clsx';

import { SectionHeadingProps } from './SectionHeading.interface';
import { useStyles } from './SectionHeading.styles';

function SectionHeading(props: SectionHeadingProps) {
  const { className, title, id } = props;
  const classes = useStyles(props);

  return (
    <section className={classNames(classes.root, className)}>
      <h2 className={classes.title} {...(id && { id })}>
        {title}
      </h2>
    </section>
  );
}
export default SectionHeading;
